import request from 'Utils/Helper/Request';
import auth from 'Utils/Helper/AuthHelpers';

export const API = process.env.REACT_APP_MTN_BASE_API_URL;

const clean = (params) => {
  if (!params) return undefined;
  const out = {};
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') out[k] = v;
  });
  return Object.keys(out).length ? out : undefined;
};

export const apiGet = (path, params, opts = {}) =>
  request(`${API}${path}`, { method: 'GET', params: clean(params), ...opts });

export const apiPost = (path, body = {}, opts = {}) =>
  request(`${API}${path}`, { method: 'POST', body, ...opts });

export const apiPut = (path, body = {}, opts = {}) =>
  request(`${API}${path}`, { method: 'PUT', body, ...opts });

export const apiDelete = (path, opts = {}) => request(`${API}${path}`, { method: 'DELETE', ...opts });

/** Multipart upload: fields is an object or array of [name, value] pairs (repeat names allowed). */
export const apiUpload = (path, fields, opts = {}) => {
  const form = new FormData();
  const pairs = Array.isArray(fields) ? fields : Object.entries(fields);
  pairs.forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    form.append(k, v);
  });
  return request(`${API}${path}`, { method: 'POST', body: form, ...opts });
};

export const withKey = (key) => ({ headers: { Authorization: `Bearer ${key}` } });

/** A readable message from a failed request. */
export const apiError = (err, fallback = 'Something went wrong. Try again.') =>
  err?.response?.payload?.message || (err?.message && err.message !== 'Failed to fetch' ? err.message : null) ||
  (err?.message === 'Failed to fetch' ? 'Cannot reach the server. Check your connection.' : fallback);

/** Downloads a protected file (document, ZIP pack) with the session token. */
export async function apiDownload(path, fallbackName = 'download') {
  const token = auth.getToken();
  const res = await fetch(`${API}${path}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) {
    let message = `Download failed (${res.status})`;
    try {
      message = (await res.json()).message || message;
    } catch (e) {
      /* not JSON */
    }
    throw new Error(message);
  }
  const blob = await res.blob();
  const cd = res.headers.get('Content-Disposition') || '';
  const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  const name = match ? decodeURIComponent(match[1]) : fallbackName;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
